import React from 'react';

import Default from '@common/embedded/academy/link/Default';

const components = [
  {
    component: Default,
    key: 'Default'
  }
];

const AcademyLinkEmbed = ({ data }) => {
  const { style } = data;
  const Component = components.find(x => x.key === style)?.component || Default;
  return <Component data={data}/>;
}

export default AcademyLinkEmbed
